module.exports = __webpack_public_path__ + "static/img/musicverse-logo.70b5b1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/musicverse-logo.png
// module id = ipZJ
// module chunks = 1